import { cn } from "@/lib/utils"
import { TestimonialCard } from "@/components/ui/testimonials-card"
import type { TestimonialAuthor } from "@/components/ui/testimonials-card"

interface TestimonialWithMarqueeProps {
  title: string
  description?: string
  testimonials: Array<{
    author: TestimonialAuthor
    text: string
    href?: string
  }>
  className?: string
}

export function TestimonialWithMarquee({ 
  title,
  testimonials,
  className 
}: TestimonialWithMarqueeProps) {
  return (
    <section className={cn(
      "bg-background text-foreground",
      "py-12 md:py-24 px-0",
      className
    )}>
      <div className=" flex flex-col items-center gap-4 text-center sm:gap-16">
        <div className="flex flex-col items-center gap-4 px-4 sm:gap-8">
          <h2 className="text-3xl font-normal leading-tight sm:text-5xl sm:leading-tight text-balance">
            {title}
          </h2>
          {/* <p className="text-md max-w-[600px] font-medium text-muted-foreground sm:text-xl">
            {description}
          </p> */}
        </div>

        <div className="relative flex w-full max-w-full flex-col items-center justify-center overflow-x-hidden">
          <div className="group flex w-full max-w-full overflow-x-hidden p-2 [--gap:1rem] [gap:var(--gap)] flex-row [--duration:200s]">
            <div 
              className="flex shrink-0 justify-around [gap:var(--gap)] flex-row group-hover:[animation-play-state:paused]"
              style={{
                animation: `marquee var(--duration, 40s) linear infinite`
              }}
            >
              {[...Array(4)].map((_, setIndex) => (
                testimonials.map((testimonial, i) => (
                  <TestimonialCard 
                    key={`${setIndex}-${i}`}
                    {...testimonial}
                  />
                ))
              ))}
            </div>
          </div>

          <div className="pointer-events-none absolute inset-y-0 left-0 hidden w-1/3 bg-gradient-to-r from-background sm:block" />
          <div className="pointer-events-none absolute inset-y-0 right-0 hidden w-1/3 bg-gradient-to-l from-background sm:block" />
        </div>
      </div>
    </section>
  )
}